import { store } from '@/decorators/store';
import { Table } from '@/entities/Table';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'TableStore' })
export class TableStore extends AbstractEntityStore<Table> {
  protected entityIdKey = 'id';
}
